import { FaHeart, FaRegHeart } from "react-icons/fa";
import Clothes from "../models/clothes/clothes.model";

interface ProductCardProps {
    item: Clothes;
    isFavorite?: boolean;
    onToggleFavorite?: (item: Clothes, e: React.MouseEvent) => void;
    onClick: (item: Clothes) => void;
    showFavoriteIcon?: boolean;
    /** When set, favorite icon is hidden for the poster (seller) of this product */
    currentUserId?: string | null;
}

const ProductCard = ({
    item,
    isFavorite = false,
    onToggleFavorite,
    onClick,
    showFavoriteIcon = true,
    currentUserId,
}: ProductCardProps) => {
    const isOwnPost = !!currentUserId && item.seller_id === currentUserId;
    const showHeart = showFavoriteIcon && !isOwnPost;
    const handleHeartClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        onToggleFavorite?.(item, e);
    };

    return (
        <div
            role="button"
            tabIndex={0}
            onClick={() => onClick(item)}
            onKeyDown={(e) => e.key === "Enter" && onClick(item)}
            className="bg-white rounded-lg shadow overflow-hidden text-left hover:shadow-md transition cursor-pointer"
        >
            <div className="aspect-[3/4] bg-gray-100 relative">
                {item.images?.[0] ? (
                    <img
                        src={item.images[0]}
                        alt={item.name}
                        className="w-full h-full object-cover"
                    />
                ) : (
                    <div className="w-full h-full flex items-center justify-center text-gray-400">No image</div>
                )}
                {showHeart && (
                    <button
                        type="button"
                        onClick={handleHeartClick}
                        className="absolute top-2 right-2 p-2 rounded-full bg-white/90 hover:bg-white shadow-sm transition z-10"
                        aria-label={isFavorite ? "Hiq nga të preferuarat" : "Shto te të preferuarat"}
                    >
                        {isFavorite ? (
                            <FaHeart className="text-lg" color="#ed1b23" />
                        ) : (
                            <FaRegHeart className="text-lg" color="#aaa" />
                        )}
                    </button>
                )}
            </div>
            <div className="p-2">
                <p className="font-medium text-gray-800 truncate">{item.name}</p>
                <p className="text-sm text-[#704e37]">
                    {item.prices?.isFree ? "Falas" : `${item.prices?.sellPrice ?? 0} €`}
                </p>
            </div>
        </div>
    );
};

export default ProductCard;
